import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Button, Col, Empty, Input, Modal, Row, Table } from "antd";
import {useContext, useState} from "react";
import apiMaestras from "../../../../api/Maestras/api-maestras";
import { Ciclo } from "../../../../models/Maestras/maestras.model";
import { openNotification } from "../../../../utils/Notifactions";
import {TemplateContext} from "../../../../utils/template_context";

interface IModalCiclo {
    openModal: boolean,
    setOpenModal: Function,
    isEdit: boolean,
    ciclos: Ciclo[],
    obtenerCiclo: Function,
    datos: Ciclo,
    setDatos: Function,
}


export const ModalCiclo = ({ openModal, setOpenModal, isEdit, ciclos, obtenerCiclo, datos, setDatos }: IModalCiclo) => {
    const onCancel = () => {
        setOpenModal(false)
    }
    const context = useContext(TemplateContext);
    const [ciclo, setCiclo] = useState<Ciclo>({
        nombre: ''
    })

    const [datosCiclos, setDatosCiclos] = useState<Ciclo>({
        id: 0,
        nombre: '',
        fecha_actualizacion: '',
        fecha_creacion: ''
    })

    const [modalVisible, setModalVisible] = useState(false);
    const editCiclo = (datos: Ciclo) => {
        setDatosCiclos(datos);
        setModalVisible(true);
    }

    const addCiclo = async () => {
        if (ciclo.nombre !== '') {
            try {
                const data = await apiMaestras.crearCiclo(ciclo);
                if(!data.ok){
                    return openNotification({
                        titulo: "Error",
                        descripcion: data.message,
                        placement: "bottomRight",
                      })
                }
                obtenerCiclo();
                setCiclo({
                    nombre: ''
                })
            } catch (error) {
                console.log(error);
            }
        }
    }

    const actualizarCiclo = async () => {
        try {
            const resp = await apiMaestras.actualizarCiclo(datosCiclos);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerCiclo();
            setModalVisible(false)
        } catch (error) {
            console.log(error);
        }
    }

    const guardarTodo = () => {
        obtenerCiclo();
        setOpenModal(false);
        setCiclo({
            nombre: '',
        })
    }

    const guardarEdicion = async () => {
        try {
            const resp = await apiMaestras.actualizarCiclo(datos);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerCiclo();
            setOpenModal(false)
        } catch (error) {
            console.log(error);
        }
    }

    const deleteCiclo = async (datos: Ciclo) => {
        try {
            const resp = await apiMaestras.eliminarCiclo(datos.id);
            if(!resp.ok){
                return openNotification({
                    titulo: "Error",
                    descripcion: resp.message,
                    placement: "bottomRight",
                  });
            }
            obtenerCiclo();
        } catch (error) {
            console.log(error);
        }
    }

    const columns: any = [
        {
            title: "Nombre Ciclo",
            key: "nombre",
            dataIndex: "nombre",
            //  fixed: context.device === "md"? "left": false,
            width: 2000,
        },
        {
            title: (
                <div>
                    <div className="titleAcciones">Acciones</div>
                    <div className="controls">
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Editar
                        </div>
                        <div className="background-color-FFFFFF line-height-0 font-family-Montserrat-Regular font-size-9px font-color-707070">
                            Eliminar
                        </div>
                    </div>
                </div>
            ),
            key: 'actions',
            width: 150,
            fixed: context.device === "lg"? "right": false,
            render: (datos: Ciclo) => (
                <div className="controls">
                    <EditOutlined onClick={() => editCiclo(datos)} />
                    <DeleteOutlined onClick={() => deleteCiclo(datos)} />
                </div>
            )
        },
    ]


    return (
        <>
            <Modal
                title={
                    <>
                        {isEdit
                            ?
                            (
                                <div>Editar Ciclo</div>
                            )
                            :
                            (

                                <div>Crear Ciclo</div>
                            )
                        }
                    </>
                }
                visible={openModal}
                onCancel={onCancel}
                width={1000}
                footer={
                    <>
                        {isEdit
                            ?
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarEdicion}>Guardar y Finalizar</Button>
                                    </Col>
                                </Row>
                            )
                            :
                            (
                                <Row justify="end" gutter={[24, 24]}>
                                    <Col>
                                        <Button className="button-blanco-radius" onClick={() => setOpenModal(false)}>Cancelar</Button>
                                    </Col>
                                    <Col>
                                        <Button className="button-azul-radius" onClick={guardarTodo}>Cerrar</Button>
                                    </Col>
                                </Row>
                            )
                        }
                    </>
                }
            >
                {
                    isEdit ?
                        (
                            <Row>
                                <Col span={24}>
                                    <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                        Nombre ciclo
                                    </span>
                                    <Input value={datos.nombre} onChange={(e) => setDatos({ ...datos, nombre: e.target.value })} />
                                </Col>
                            </Row>
                        )
                        :
                        (
                            <>
                                <Row>
                                    <Col span={24}>
                                        <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                            Nombre ciclo
                                        </span>
                                        <Input value={ciclo.nombre} onChange={(e) => setCiclo({ ...ciclo, nombre: e.target.value })} />
                                    </Col>
                                </Row >
                                <Row justify="end">
                                    <Col>
                                        <Button className="button-azul-radius" onClick={addCiclo}>Guardar</Button>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div>Ciclos creados</div>
                                    </Col>
                                    <Col>
                                        <Table
                                            dataSource={ciclos}
                                            columns={columns}
                                            locale={{ emptyText: <Empty description="No se han diligenciados datos para está sección" style={{ padding: "50px" }} /> }}
                                            style={{ borderTop: "1px solid #C4C4C4" }}
                                            size="small"
                                            bordered={false}
                                            pagination={false}
                                        />
                                    </Col>
                                </Row>
                            </>
                        )
                }
            </Modal >
            {modalVisible &&
                <Modal
                    title="Editar ciclo"
                    visible={modalVisible}
                    onCancel={() => setModalVisible(false)}
                    width={1000}
                    footer={
                        <Row justify="end" gutter={[24, 24]}>
                            <Col>
                                <Button className="button-blanco-radius" onClick={() => setModalVisible(false)}>Cancelar</Button>
                            </Col>
                            <Col>
                                <Button className="button-azul-radius" onClick={actualizarCiclo}>Guardar Cambios</Button>
                            </Col>
                        </Row>
                    }
                >
                    <Row>
                        <Col span={24}>
                            <span className="width-100 font-family-Montserrat-Bold font-size-12px container-span-titulos-bottom font-color-707070">
                                Nombre ciclo
                            </span>
                            <Input value={datosCiclos.nombre} onChange={(e) => setDatosCiclos({ ...datosCiclos, nombre: e.target.value })} />
                        </Col>
                    </Row>

                </Modal>
            }
        </>
    )
}
